import React, { createContext, useCallback, useEffect, useState } from 'react';
import authService from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const updateCurrentUser = useCallback((nextUser) => {
    const normalizedUser = authService.setCurrentUser(nextUser);
    setUser(normalizedUser);
  }, []);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      updateCurrentUser(currentUser);
    }
    setLoading(false);
  }, [updateCurrentUser]);

  const login = async (username, password) => {
    try {
      const data = await authService.login(username, password);
      updateCurrentUser(data.user);
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'فشل تسجيل الدخول' 
      };
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, updateCurrentUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
